import React from 'react'

export const BoldIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.5609 7.31641C12.5259 6.60877 13.1231 5.42833 12.9785 4.10878C12.7809 2.30548 11.1432 0.99999 9.32916 1H2V2L3.44721 2.72361C3.786 2.893 4 3.23926 4 3.61803V12.382C4 12.7607 3.786 13.107 3.44721 13.2764L2 14V15H9.82266C11.9265 15 13.8031 13.4525 13.9845 11.3565C14.1409 9.55075 13.0963 7.96788 11.5609 7.31641ZM7 3H8C9.10455 3 10 3.89539 10 5C10 6.10455 9.10455 7 8 7H7V3ZM9 13H7V9H9C10.1046 9 11 9.89539 11 11C11 12.1046 10.1046 13 9 13Z"
        fill="#647696"
      />
    </svg>
  )
}

export const CodeIcon = (props) => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0702 0.14801C15.8724 0.518295 16.2226 1.46885 15.8524 2.27114L10.6828 13.4718C10.3125 14.2741 9.36195 14.6243 8.55967 14.2541C7.75739 13.8838 7.40718 12.9332 7.77747 12.1309L12.947 0.930214C13.3173 0.127929 14.2679 -0.222275 15.0702 0.14801ZM7.44033 0.14801C8.24261 0.518295 8.59282 1.46885 8.22253 2.27114L3.05297 13.4718C2.68269 14.2741 1.73213 14.6243 0.929848 14.2541C0.127563 13.8838 -0.222642 12.9332 0.147644 12.1309L5.3172 0.930214C5.68749 0.127929 6.63804 -0.222275 7.44033 0.14801Z"
        fill="#647696"
      />
    </svg>
  )
}

export const DividerIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="6.5" width="16" height="3" fill="#647696" />
    </svg>
  )
}

export const ImageIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 16H1C0.4 16 0 15.6 0 15V1C0 0.4 0.4 0 1 0H15C15.6 0 16 0.4 16 1V15C16 15.6 15.6 16 15 16ZM2 14H14V2H2V14Z"
        fill="#647696"
      />
      <path d="M6 4C6.6 4 7 4.4 7 5C7 5.6 6.6 6 6 6C5.4 6 5 5.6 5 5C5 4.4 5.4 4 6 4Z" fill="#647696" />
      <path d="M3 12L5 8L7 10L10 6L13 12H3Z" fill="#647696" />
    </svg>
  )
}

export const ItalicIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2V0H6V2H7.27066C7.57493 2 7.80867 2.26949 7.76563 2.57071L6.25553 13.1414C6.18515 13.6341 5.76323 14 5.26558 14H4V16H10V14H8.72934C8.42506 14 8.19133 13.7305 8.23436 13.4293L9.74447 2.85858C9.81485 2.36593 10.2368 2 10.7344 2H12Z"
        fill="#647696"
      />
    </svg>
  )
}

export const QuoteIcon = (props) => {
  return (
    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 6.39935H12.1193C12.1856 3.57107 12.9878 3.25002 13.9953 3.15839L14.3838 3.11022V0.000244141L13.936 0.0242439C12.6204 0.0982643 11.1658 0.335436 10.1954 1.53342C9.34473 2.5836 8.9697 4.29931 8.9697 6.93309V11.8135H16V6.39935Z"
        fill="#647696"
      />
      <path
        d="M7.0303 11.8135L7.0303 6.39936L3.20137 6.39936C3.26772 3.57107 4.04396 3.25002 5.05147 3.15839L5.41414 3.11022L5.41414 0.000244925L4.99216 0.0242447C3.67652 0.098265 2.20897 0.335437 1.23854 1.53342C0.387959 2.5836 -2.30252e-07 4.29932 0 6.93309L4.26659e-07 11.8135L7.0303 11.8135Z"
        fill="#647696"
      />
    </svg>
  )
}

export const TextClearFormatting = (props) => {
  return (
    <svg
      height={16}
      viewBox="0 4 40 40"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="#647696" d="M6.54 10L4 12.55l13.94 13.94L13 38h6l3.14-7.32L33.46 42 36 39.45 7.09 10.55 6.54 10zM12 10v.36L17.64 16h4.79l-1.44 3.35 4.2 4.2L28.43 16H40v-6H12z" />
    </svg>
  )
}

export const OrderedListIcon = (props) => {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.00834 3.54413V0L0 0.300035V1.01184H0.960516V3.54413H0V4.33H2.96885V3.54413H2.00834Z" fill="#647696" />
      <path d="M5 1H15V3H5V1Z" fill="#647696" />
      <path d="M5 7H15V9H5V7Z" fill="#647696" />
      <path d="M15 13H5V15H15V13Z" fill="#647696" />
      <path
        d="M1.39494 9.59405L1.4039 9.62843H3.02089V10.33H0.0392091V9.7134L1.43805 8.25951C1.61345 8.05862 1.75857 7.87927 1.84127 7.72167C1.92398 7.5642 1.96537 7.42704 1.96537 7.31084C1.96537 7.14535 1.92346 7.01281 1.8398 6.91426C1.75606 6.81586 1.63046 6.76563 1.46306 6.76563C1.31336 6.76563 1.19568 6.82702 1.10999 6.9541C1.02431 7.08108 0.981447 7.26055 0.981434 7.43592H0.00650292L0.000527367 7.42242C-0.00939204 7.02453 0.120636 6.69145 0.390492 6.41478C0.660347 6.13811 1.01788 6 1.46302 6C1.93573 6 2.30458 6.11672 2.5695 6.34901C2.83433 6.58158 2.96683 6.90071 2.96683 7.30446C2.96683 7.57623 2.8964 7.81864 2.75565 8.02742C2.61471 8.23625 2.35533 8.55072 1.97708 8.96236L1.39494 9.59405Z"
        fill="#647696"
      />
      <path
        d="M2.32121 13.7794C2.54693 13.8624 2.72344 13.9877 2.85084 14.1567C2.97823 14.3255 3.04179 14.5269 3.04179 14.7623C3.04179 15.1482 2.8943 15.4504 2.5991 15.6712C2.30389 15.8922 1.92675 16 1.46755 16C1.07211 16 0.726297 15.8914 0.430155 15.684C0.134013 15.4767 -0.00918148 15.1663 0.000455831 14.7727L0.00619139 14.7356H0.96126C0.96126 14.9074 1.01374 15.0032 1.11897 15.0948C1.2242 15.1864 1.3519 15.2512 1.50239 15.2512C1.67411 15.2512 1.8111 15.2017 1.9134 15.1053C2.01551 15.0088 2.0667 14.8847 2.0667 14.7379C2.0667 14.5335 2.01317 14.3791 1.90607 14.2855C1.79897 14.1919 1.64805 14.1344 1.45315 14.1344H0.994737V13.4472H1.45315C1.62873 13.4472 1.76373 13.3921 1.85831 13.2975C1.95277 13.203 2.00002 13.0638 2.00002 12.896C2.00002 12.7628 1.95761 12.6529 1.87275 12.5622C1.78777 12.4715 1.66435 12.4299 1.50228 12.4299C1.375 12.4299 1.26306 12.474 1.16661 12.5474C1.07008 12.6207 1.02197 12.6742 1.02197 12.846H0.0727942L0.0669416 12.8136C0.0553144 12.4779 0.187505 12.191 0.463398 11.9826C0.73929 11.7742 1.07398 11.67 1.46755 11.67C1.92484 11.67 2.29039 11.7746 2.56429 11.984C2.83819 12.1933 2.97518 12.4899 2.97518 12.8738C2.97518 13.0646 2.91592 13.2408 2.79723 13.4019C2.67861 13.5629 2.51989 13.6887 2.32121 13.7794Z"
        fill="#647696"
      />
    </svg>
  )
}

export const UnorderedListIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 2C4 3.10457 3.10457 4 2 4C0.89543 4 0 3.10457 0 2C0 0.89543 0.89543 0 2 0C3.10457 0 4 0.89543 4 2Z"
        fill="#647696"
      />
      <path
        d="M4 8C4 9.10457 3.10457 10 2 10C0.89543 10 0 9.10457 0 8C0 6.89543 0.89543 6 2 6C3.10457 6 4 6.89543 4 8Z"
        fill="#647696"
      />
      <path
        d="M2 16C3.10457 16 4 15.1046 4 14C4 12.8954 3.10457 12 2 12C0.89543 12 0 12.8954 0 14C0 15.1046 0.89543 16 2 16Z"
        fill="#647696"
      />
      <path d="M6 1H16V3H6V1Z" fill="#647696" />
      <path d="M16 7H6V9H16V7Z" fill="#647696" />
      <path d="M6 13H16V15H6V13Z" fill="#647696" />
    </svg>
  )
}

export const UndoIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 8.00023C16 11.7798 12.9243 14.8549 9.14528 14.8549C8.45642 14.8549 7.89824 14.2968 7.89824 13.6079C7.89824 12.919 8.45642 12.3609 9.14528 12.3609C11.5491 12.3609 13.5059 10.4045 13.5059 8.00023C13.5059 5.59594 11.5491 3.63958 9.14528 3.63958C6.89113 3.63958 5.03305 5.357 4.80758 7.55129H7.13456L3.56803 12.2107L0 7.55129H2.31301C2.54645 3.98177 5.5174 1.14551 9.14528 1.14551C12.9243 1.14551 16 4.2207 16 8.00023Z"
        fill="#647696"
      />
    </svg>
  )
}

export const RedoIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 8.00023C0 11.7798 3.0757 14.8549 6.85472 14.8549C7.54358 14.8549 8.10176 14.2968 8.10176 13.6079C8.10176 12.919 7.54358 12.3609 6.85472 12.3609C4.45093 12.3609 2.49408 10.4045 2.49408 8.00023C2.49408 5.59594 4.45093 3.63958 6.85472 3.63958C9.10887 3.63958 10.967 5.357 11.1924 7.55129H8.86544L12.432 12.2107L16 7.55129H13.687C13.4535 3.98177 10.4826 1.14551 6.85472 1.14551C3.0757 1.14551 0 4.2207 0 8.00023Z"
        fill="#647696"
      />
    </svg>
  )
}

export const HeadingIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.34906 14.9996V14.1761H9.60827C9.83154 14.1761 10.04 14.1599 10.235 14.1289C10.4308 14.0966 10.5997 14.0305 10.743 13.9322C10.8863 13.8338 11.0018 13.6909 11.0885 13.5063C11.1748 13.3212 11.2174 13.0755 11.2174 12.7682V8.17296H4.83962V12.7682C4.83962 13.075 4.8823 13.3203 4.96855 13.5067C5.05481 13.6909 5.16981 13.8342 5.31357 13.9322C5.45732 14.0314 5.62758 14.0961 5.8257 14.1289C6.02426 14.1604 6.23091 14.1765 6.44834 14.1765H6.70755V15H1V14.1765H1.24933C1.4726 14.1765 1.68104 14.1604 1.87646 14.1289C2.07143 14.097 2.24169 14.0314 2.38904 13.9322C2.53549 13.8329 2.65049 13.6909 2.7345 13.5067C2.81716 13.3217 2.85804 13.075 2.85804 12.7682V3.15454C2.85804 2.86748 2.81491 2.63657 2.72911 2.46047C2.64196 2.28437 2.52516 2.14915 2.37871 2.05346C2.23181 1.95777 2.06155 1.89533 1.86568 1.86658C1.67206 1.83738 1.46586 1.82345 1.24888 1.82345H1V1H6.70755V1.82345H6.44834C6.23136 1.82345 6.02471 1.83917 5.8257 1.87152C5.62803 1.90297 5.45777 1.969 5.31357 2.06783C5.17026 2.16667 5.05526 2.30863 4.96855 2.49416C4.8823 2.6788 4.83962 2.92498 4.83962 3.23136V7.19497H11.2165V3.23136C11.2165 2.92453 11.1734 2.6788 11.0876 2.49371C11.0018 2.30863 10.8863 2.16622 10.7426 2.06783C10.5988 1.969 10.4299 1.90341 10.2345 1.87152C10.0391 1.83917 9.83154 1.82345 9.60737 1.82345H9.34816V1H15.0557V1.82345H14.8073C14.5836 1.82345 14.3756 1.83917 14.1801 1.87152C13.9852 1.90297 13.8154 1.969 13.6676 2.06783C13.5211 2.16667 13.4061 2.30863 13.3226 2.49371C13.239 2.67835 13.1981 2.92453 13.1981 3.23136V12.8639C13.1981 13.1514 13.2417 13.3827 13.327 13.558C13.4133 13.7341 13.5305 13.8666 13.677 13.9551C13.8235 14.0449 13.9937 14.1038 14.1896 14.133C14.3845 14.1617 14.5903 14.1761 14.8064 14.1761H15.0562V14.9996H9.34906Z"
        fill="#647696"
      />
    </svg>
  )
}
export const H1Icon = () => {
  return (
    <svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.932528 9.5H2.64524V5.48366H7.02628V9.5H8.74361V0.0454543H7.02628V4.04794H2.64524V0.0454543H0.932528V9.5ZM14.3596 0.0454543H12.7299L10.3801 1.55504V3.12464L12.5914 1.712H12.6468V9.5H14.3596V0.0454543Z"
        fill="#718096"
      />
    </svg>
  )
}
export const H2Icon = () => {
  return (
    <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.932528 10.5H2.64524V6.48366H7.02628V10.5H8.74361V1.04545H7.02628V5.04794H2.64524V1.04545H0.932528V10.5ZM10.514 10.5H16.9956V9.06889H12.8777V9.00426L14.5073 7.34695C16.3446 5.58345 16.8525 4.72479 16.8525 3.65838C16.8525 2.07493 15.5645 0.916193 13.6625 0.916193C11.7882 0.916193 10.4586 2.07954 10.4586 3.87536H12.0882C12.0882 2.91051 12.6976 2.30575 13.6394 2.30575C14.5396 2.30575 15.209 2.85511 15.209 3.74609C15.209 4.53551 14.7289 5.09872 13.7963 6.0451L10.514 9.26278V10.5Z"
        fill="#718096"
      />
    </svg>
  )
}
export const H3Icon = () => {
  return (
    <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.932528 10.5H2.64524V6.48366H7.02628V10.5H8.74361V1.04545H7.02628V5.04794H2.64524V1.04545H0.932528V10.5ZM13.9071 10.6293C15.9292 10.6293 17.4018 9.47053 17.3972 7.87322C17.4018 6.69141 16.6632 5.84197 15.3382 5.6527V5.57883C16.3631 5.35724 17.051 4.59553 17.0463 3.53374C17.051 2.09339 15.823 0.916193 13.9348 0.916193C12.0975 0.916193 10.6756 2.0103 10.6387 3.59375H12.2868C12.3145 2.79972 13.0531 2.30575 13.9256 2.30575C14.8074 2.30575 15.3936 2.84126 15.389 3.6353C15.3936 4.46165 14.7104 5.01101 13.7317 5.01101H12.8961V6.33132H13.7317C14.9274 6.33132 15.6383 6.93146 15.6337 7.78551C15.6383 8.62109 14.9135 9.19354 13.9025 9.19354C12.9515 9.19354 12.2175 8.69957 12.176 7.92862H10.4402C10.4863 9.52592 11.9128 10.6293 13.9071 10.6293Z"
        fill="#718096"
      />
    </svg>
  )
}
export const H4Icon = () => {
  return (
    <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.932528 9.5H2.64524V5.48366H7.02628V9.5H8.74361V0.0454543H7.02628V4.04794H2.64524V0.0454543H0.932528V9.5ZM10.3432 7.74574H14.8535V9.5H16.4877V7.74574H17.6973V6.33771H16.4877V0.0454543H14.3549L10.3432 6.38388V7.74574ZM14.872 6.33771H12.0975V6.26385L14.7981 1.98438H14.872V6.33771Z"
        fill="#718096"
      />
    </svg>
  )
}
export const H5Icon = () => {
  return (
    <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.932528 9.5H2.64524V5.48366H7.02628V9.5H8.74361V0.0454543H7.02628V4.04794H2.64524V0.0454543H0.932528V9.5ZM13.801 9.62926C15.7999 9.62926 17.1941 8.27202 17.1941 6.39311C17.1941 4.57422 15.9292 3.26314 14.2118 3.26314C13.4455 3.26314 12.7669 3.56783 12.416 3.98331H12.3606L12.633 1.47656H16.7001V0.0454543H11.2157L10.7218 4.92045L12.2683 5.17436C12.5868 4.82351 13.187 4.58807 13.7548 4.59268C14.7935 4.5973 15.5414 5.36364 15.5368 6.43466C15.5414 7.49183 14.812 8.24432 13.801 8.24432C12.9469 8.24432 12.2591 7.70419 12.199 6.92862H10.5371C10.5833 8.49822 11.9544 9.62926 13.801 9.62926Z"
        fill="#718096"
      />
    </svg>
  )
}
export const H6Icon = () => {
  return (
    <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.932528 10.5H2.64524V6.48366H7.02628V10.5H8.74361V1.04545H7.02628V5.04794H2.64524V1.04545H0.932528V10.5ZM13.9764 10.6293C16.0169 10.6431 17.388 9.2397 17.3833 7.37003C17.388 5.58345 16.1138 4.29084 14.4565 4.29084C13.4409 4.29084 12.5453 4.7848 12.0929 5.5973H12.0282C12.0328 3.6076 12.7623 2.39808 14.0733 2.39808C14.8858 2.39808 15.4352 2.86896 15.6106 3.59375H17.2956C17.0925 2.0657 15.8599 0.916193 14.0733 0.916193C11.802 0.916193 10.3663 2.80895 10.3663 6.04048C10.3617 9.50746 12.1621 10.62 13.9764 10.6293ZM13.9672 9.24432C12.9561 9.24432 12.2175 8.40874 12.2129 7.42081C12.2221 6.42827 12.9885 5.5973 13.9902 5.5973C14.992 5.5973 15.726 6.39133 15.7214 7.40696C15.726 8.44105 14.9689 9.24432 13.9672 9.24432Z"
        fill="#718096"
      />
    </svg>
  )
}
export const PlusIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 1V11" stroke="#718096" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M1 6H11" stroke="#718096" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  )
}
export const LinkIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M1.00003 15.9999C0.802281 15.9999 0.608982 15.9412 0.444573 15.8313C0.280163 15.7214 0.152023 15.5653 0.0763531 15.3826C0.000683047 15.1999 -0.0191199 14.9988 0.0194476 14.8049C0.0580152 14.6109 0.153222 14.4328 0.293031 14.2929L5.29303 9.29292C5.48163 9.11076 5.73424 9.00997 5.99643 9.01224C6.25863 9.01452 6.50944 9.11969 6.69485 9.3051C6.88026 9.49051 6.98543 9.74132 6.98771 10.0035C6.98998 10.2657 6.88919 10.5183 6.70703 10.7069L1.70703 15.7069C1.51954 15.8945 1.26523 15.9999 1.00003 15.9999Z"
        fill="#647696"
      />
      <path
        d="M0.96609 10.7918L2.48809 9.26882L2.43309 9.14082C2.42709 9.12482 1.85709 7.55682 2.70809 6.70582L6.73809 2.67582C7.58009 1.83382 9.13809 2.38882 9.13809 2.38782L9.30109 2.45782L10.8231 0.934821L9.89009 0.534821C9.77709 0.490821 7.10009 -0.511179 5.32309 1.26282L1.29309 5.29282C-0.47991 7.06382 0.52309 9.74582 0.58109 9.89382L0.96609 10.7918Z"
        fill="#647696"
      />
      <path
        d="M5.20801 15.0338L6.73101 13.5118L6.85901 13.5668C6.87501 13.5728 8.44301 14.1428 9.29401 13.2918L13.324 9.26178C14.166 8.41978 13.611 6.86178 13.612 6.86178L13.542 6.69878L15.065 5.17578L15.465 6.10878C15.509 6.22178 16.511 8.90278 14.737 10.6758L10.707 14.7058C8.93601 16.4788 6.25401 15.4758 6.10701 15.4178L5.20801 15.0338Z"
        fill="#647696"
      />
      <path
        d="M10 6.99992C9.80228 6.99988 9.60898 6.94121 9.44457 6.83132C9.28016 6.72144 9.15202 6.56527 9.07635 6.38257C9.00068 6.19987 8.98088 5.99884 9.01945 5.80489C9.05802 5.61093 9.15322 5.43277 9.29303 5.29292L14.293 0.292919C14.4816 0.110761 14.7342 0.00996641 14.9964 0.0122448C15.2586 0.0145233 15.5094 0.119692 15.6948 0.3051C15.8803 0.490508 15.9854 0.741321 15.9877 1.00352C15.99 1.26571 15.8892 1.51832 15.707 1.70692L10.707 6.70692C10.5195 6.89447 10.2652 6.99986 10 6.99992Z"
        fill="#647696"
      />
    </svg>
  )
}

export const UnderlineIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16 14H0V16H16V14Z" fill="#647696" />
      <path
        d="M15 0H9V1L10.4472 1.72361C10.786 1.893 11 2.23926 11 2.61803V6.8816C11 8.33247 10.0222 9.6652 8.59793 9.94185C6.68269 10.3139 5 8.84987 5 7V2.61803C5 2.23926 5.214 1.893 5.55279 1.72361L7 1V0H1V1L2.44721 1.72361C2.786 1.893 3 2.23926 3 2.61803V6.777C3 9.38679 4.90274 11.722 7.50018 11.9755C10.4805 12.2665 13 9.92173 13 7V2.61803C13 2.23926 13.214 1.89299 13.5528 1.7236L15 1V0Z"
        fill="#647696"
      />
    </svg>
  )
}

export const StrikethroughIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 13.2792V11H7V13.2792C7 13.7097 6.72455 14.0918 6.31622 14.2279L4 15V16H8H12V15L9.68378 14.2279C9.27545 14.0918 9 13.7097 9 13.2792Z"
        fill="#647696"
      />
      <path
        d="M9 2H12.382C12.7607 2 13.107 2.21399 13.2764 2.5528L14 4H15V0H8H1V4H2L2.72363 2.5528C2.89301 2.21399 3.23926 2 3.61804 2H7V7H9V2Z"
        fill="#647696"
      />
      <path d="M16 9V7H9H7H0V9H16Z" fill="#647696" />
    </svg>
  )
}

export const SuperscriptIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0596 4.21309V5H16V3.40966H15.0961L14.9767 4.07774C14.9596 4.16263 14.9253 4.1796 14.8402 4.1796H13.5862L14.5501 3.26559L14.5557 3.26034C15.1761 2.67057 15.727 2.14688 15.727 1.35359C15.727 0.558413 15.258 0 13.9359 0C13.0403 0 12.0083 0.220251 12 1.56511L13.1596 1.66698C13.1596 1.06635 13.3558 0.914012 13.8253 0.914012C14.2773 0.914012 14.4308 1.14206 14.4308 1.45545C14.4308 1.92338 14.0855 2.25565 13.2781 3.0324C13.2534 3.05618 13.2283 3.08036 13.2027 3.10499L12.0596 4.21309Z"
        fill="#647696"
      />
      <path
        d="M0 2H11V5.42858H10.0833L9.42004 4.18811C9.26475 3.89772 8.94731 3.71429 8.60012 3.71429H6.41665V11.668C6.41665 12.0369 6.66913 12.3644 7.04344 12.4811L9.16667 13.1429V14H1.83333V13.1429L3.95653 12.4811C4.33084 12.3644 4.58332 12.0369 4.58332 11.668V3.71429H2.39985C2.05265 3.71429 1.73525 3.89772 1.57997 4.18811L0.916664 5.42858H0V2Z"
        fill="#647696"
      />
    </svg>
  )
}
export const CheckboxIcon = () => {
  return (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 2H9C9 0.896875 8.10313 0 7 0C5.89688 0 5 0.896875 5 2H1C0.5 2 0 2.5 0 3V15C0 15.5 0.5 16 1 16H13C13.5 16 14 15.5 14 15V3C14 2.5 13.5 2 13 2ZM7 1.5C7.275 1.5 7.5 1.725 7.5 2C7.5 2.275 7.275 2.5 7 2.5C6.725 2.5 6.5 2.275 6.5 2C6.5 1.725 6.725 1.5 7 1.5ZM12.5 14.25C12.5 14.3875 12.3875 14.5 12.25 14.5H1.75C1.6125 14.5 1.5 14.3875 1.5 14.25V3.75C1.5 3.6125 1.6125 3.5 1.75 3.5H4V4.5C4 4.775 4.225 5 4.5 5H9.5C9.775 5 10 4.775 10 4.5V3.5H12.25C12.3875 3.5 12.5 3.6125 12.5 3.75V14.25ZM4.5 10C4 10 3.5 10.5 3.5 11C3.5 11.5 4 12 4.5 12C5 12 5.5 11.5 5.5 11C5.5 10.5 5 10 4.5 10ZM9.75 7.25H7.62942L6 8.75H9.75C9.8875 8.75 10 8.6375 10 8.5V7.5C10 7.3625 9.8875 7.25 9.75 7.25ZM9.75 10.25H6.25C6.1125 10.25 6 10.3625 6 10.5V11.5C6 11.6375 6.1125 11.75 6.25 11.75H9.75C9.8875 11.75 10 11.6375 10 11.5V10.5C10 10.3625 9.8875 10.25 9.75 10.25Z"
        fill="#647696"
      />
    </svg>
  )
}
export const SubscriptIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0596 14.2131V15H15V13.4097H14.0961L13.9767 14.0777C13.9596 14.1626 13.9253 14.1796 13.8402 14.1796H12.5862L13.5501 13.2656L13.5557 13.2603C14.1761 12.6706 14.727 12.1469 14.727 11.3536C14.727 10.5584 14.258 10 12.9359 10C12.0403 10 11.0083 10.2203 11 11.5651L12.1596 11.667C12.1596 11.0664 12.3558 10.914 12.8253 10.914C13.2773 10.914 13.4308 11.1421 13.4308 11.4555C13.4308 11.9234 13.0855 12.2557 12.2781 13.0324C12.2534 13.0562 12.2283 13.0804 12.2027 13.105L11.0596 14.2131Z"
        fill="#647696"
      />
      <path
        d="M0 2H11V5.42858H10.0833L9.42004 4.18811C9.26475 3.89772 8.94731 3.71429 8.60012 3.71429H6.41665V11.668C6.41665 12.0369 6.66913 12.3644 7.04344 12.4811L9.16667 13.1429V14H1.83333V13.1429L3.95653 12.4811C4.33084 12.3644 4.58332 12.0369 4.58332 11.668V3.71429H2.39985C2.05265 3.71429 1.73525 3.89772 1.57997 4.18811L0.916664 5.42858H0V2Z"
        fill="#647696"
      />
    </svg>
  )
}

export const EmbedIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 6V3C11 2.4 10.6 2 10 2H1C0.4 2 0 2.4 0 3V13C0 13.6 0.4 14 1 14H10C10.6 14 11 13.6 11 13V10L16 12V4L11 6Z"
      fill="#647696"
    />
  </svg>
)

export const SocialEmbedIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M4.63333 13.0667L0.3 8.73333C-0.1 8.33333 -0.1 7.73333 0.3 7.33333L4.63333 3L6.03333 4.4L2.4 8.03333L6.03333 11.6667L4.63333 13.0667Z" fill="#647696" />
      <path d="M11.3667 13.0667L9.96667 11.6667L13.6 8.03333L9.96667 4.4L11.3667 3L15.7 7.33333C16.1 7.73333 16.1 8.33333 15.7 8.73333L11.3667 13.0667Z" fill="#647696" />
    </svg>
  )
}

export const AlignmentIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 1H0V3H16V1Z" fill="#647696" />
    <path d="M10 5H0V7H10V5Z" fill="#647696" />
    <path d="M16 9H0V11H16V9Z" fill="#647696" />
    <path d="M10 13H0V15H10V13Z" fill="#647696" />
  </svg>
)

export const ParagraphIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 0C4.93913 0 3.92172 0.421427 3.17157 1.17157C2.42143 1.92172 2 2.93913 2 4C2 5.06087 2.42143 6.07828 3.17157 6.82843C3.92172 7.57857 4.93913 8 6 8V16H8V2H11V16H13V2H15V0H6Z"
      fill="#647696"
    />
  </svg>
)

export const NewTabIcon = () => {
  return (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.66667 2.66667V13.3333H13.3333V10.6667H16V13.3333C16 14.0405 15.7191 14.7188 15.2189 15.2189C14.7188 15.7191 14.0405 16 13.3333 16H2.66667C1.95943 16 1.28115 15.7191 0.781048 15.2189C0.280952 14.7188 0 14.0405 0 13.3333V2.66667C0 1.95943 0.280952 1.28115 0.781048 0.781048C1.28115 0.280952 1.95943 0 2.66667 0H5.33333V2.66667H2.66667ZM6.11467 8L11.0573 3.05733L8 0H16V8L12.9427 4.94267L8 9.88533L6.11467 8Z"
        fill="#647696"
      />
    </svg>
  )
}
export const FullscreenIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14 10.4L14 12.2C14 13.1941 13.1941 14 12.2 14L10.4 14"
      stroke="#647696"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.6 14L3.8 14C2.80589 14 2 13.1941 2 12.2L2 10.4"
      stroke="#647696"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 5.6V3.8C2 2.80589 2.80589 2 3.8 2H5.6"
      stroke="#647696"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4 2L12.2 2C13.1941 2 14 2.80589 14 3.8L14 5.6"
      stroke="#647696"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const RestoreScreenIcon = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11.3999 16.0666V12.5999C11.3999 11.9372 11.9372 11.3999 12.5999 11.3999H16.0666" stroke="#647696" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.93343 11.3999L5.4001 11.3999C6.06284 11.3999 6.6001 11.9372 6.6001 12.5999L6.6001 16.0666" stroke="#647696" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.6001 1.93343L6.6001 5.4001C6.6001 6.06284 6.06284 6.6001 5.4001 6.6001L1.93343 6.6001" stroke="#647696" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.0666 6.6001L12.5999 6.6001C11.9372 6.6001 11.3999 6.06284 11.3999 5.4001L11.3999 1.93343" stroke="#647696" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
export const blockQuoteIcon = () => {
  return (
    <svg width="38" height="11" viewBox="0 0 38 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.38068 5.27273C9.38068 2.21662 7.51562 0.416193 5.03658 0.416193C2.55291 0.416193 0.692472 2.21662 0.692472 5.27273C0.692472 8.32422 2.55291 10.1293 5.03658 10.1293C5.63672 10.1293 6.19993 10.0231 6.71236 9.81996L7.49254 10.8125H9.15447L7.84339 9.1321C8.79439 8.30114 9.38068 6.98544 9.38068 5.27273ZM4.4549 6.82386L5.73367 8.50426C5.51207 8.56428 5.28125 8.59197 5.03658 8.59197C3.49929 8.59197 2.41442 7.42401 2.41442 5.27273C2.41442 3.12145 3.49929 1.95348 5.03658 1.95348C6.57848 1.95348 7.65874 3.12145 7.65874 5.27273C7.65874 6.43608 7.34482 7.30859 6.8093 7.86719L6.00604 6.82386H4.4549ZM15.4583 7.01776C15.4583 8.09801 14.6873 8.63352 13.9487 8.63352C13.1454 8.63352 12.6099 8.0657 12.6099 7.16548V2.90909H10.9387V7.42401C10.9387 9.12749 11.9082 10.0923 13.3024 10.0923C14.3642 10.0923 15.112 9.53374 15.4352 8.7397H15.5091V10H17.1294V2.90909H15.4583V7.01776ZM21.941 10.1385C24.0184 10.1385 25.3387 8.67507 25.3387 6.48224C25.3387 4.2848 24.0184 2.81676 21.941 2.81676C19.8635 2.81676 18.5432 4.2848 18.5432 6.48224C18.5432 8.67507 19.8635 10.1385 21.941 10.1385ZM21.9502 8.79972C20.8007 8.79972 20.2375 7.77486 20.2375 6.47763C20.2375 5.1804 20.8007 4.14169 21.9502 4.14169C23.0812 4.14169 23.6444 5.1804 23.6444 6.47763C23.6444 7.77486 23.0812 8.79972 21.9502 8.79972ZM30.2979 2.90909H28.8991V1.21023H27.228V2.90909H26.2216V4.2017H27.228V8.14418C27.2188 9.47834 28.1882 10.1339 29.4439 10.0969C29.9194 10.0831 30.2472 9.99077 30.4272 9.93075L30.1456 8.62429C30.0533 8.64737 29.864 8.68892 29.6562 8.68892C29.2362 8.68892 28.8991 8.54119 28.8991 7.86719V4.2017H30.2979V2.90909ZM34.7586 10.1385C36.4113 10.1385 37.547 9.33061 37.8424 8.09801L36.282 7.92259C36.0558 8.52273 35.5019 8.83665 34.7817 8.83665C33.7014 8.83665 32.9859 8.12571 32.972 6.91158H37.9117V6.39915C37.9117 3.91087 36.4159 2.81676 34.6709 2.81676C32.6396 2.81676 31.3147 4.30788 31.3147 6.49609C31.3147 8.72124 32.6212 10.1385 34.7586 10.1385ZM32.9767 5.78516C33.0274 4.88033 33.6968 4.11861 34.694 4.11861C35.6542 4.11861 36.3005 4.82031 36.3097 5.78516H32.9767Z"
        fill="#718096"
      />
    </svg>
  )
}
export const PropertyIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.52786 12.5H8.24124L8.64101 10.1797H6.61918L6.21941 12.5H4.9328L5.33257 10.1797H4L4.21597 8.94922H5.54394L5.86559 7.05078H4.54681L4.75818 5.82031H6.07697L6.47674 3.5H7.76335L7.36358 5.82031H9.38541L9.78518 3.5H11.0718L10.672 5.82031H12L11.7886 7.05078H10.4607L10.139 8.94922H11.4578L11.2418 10.1797H9.92763L9.52786 12.5ZM7.15221 7.05078L6.83056 8.94922H8.85238L9.17404 7.05078H7.15221Z"
      fill="#647696"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4ZM4 1.5H12C13.3807 1.5 14.5 2.61929 14.5 4V12C14.5 13.3807 13.3807 14.5 12 14.5H4C2.61929 14.5 1.5 13.3807 1.5 12V4C1.5 2.61929 2.61929 1.5 4 1.5Z"
      fill="#647696"
    />
  </svg>
)

// Alignments
export const LeftAlignmentIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1H16V3H0V1Z" fill="#647696" />
    <path d="M0 5H10V7H0V5Z" fill="#647696" />
    <path d="M16 9H0V11H16V9Z" fill="#647696" />
    <path d="M0 13H10V15H0V13Z" fill="#647696" />
  </svg>
)

export const RightAlignmentIcon = () => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H16V2H0V0Z" fill="#647696" />
    <path d="M6 4H16V6H6V4Z" fill="#647696" />
    <path d="M16 8H0V10H16V8Z" fill="#647696" />
    <path d="M6 12H16V14H6V12Z" fill="#647696" />
  </svg>
)

// Text Direction
export const RTLTextDirectionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_2)">
      <path d="M9.4954 0C8.51343 0 7.56853 0.389676 6.87374 1.08553C6.17896 1.78138 5.78988 2.72773 5.78988 3.7112C5.78988 4.69467 6.17896 5.64103 6.87374 6.33688C7.56853 7.03273 8.51343 7.42241 9.4954 7.42241V14.8448H11.3482V1.8556H14.1273V14.8448H15.9801V1.8556H17.8328V0H9.4954Z" fill="#647696" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.42912 19.2797L4.93145 17.691L3.58623 16.415L0 20.2075L3.58623 24L4.93145 22.724L3.42912 21.1353H24V19.2797H3.42912Z" fill="#647696" />
    </g>
    <defs>
      <clipPath id="clip0_1_2">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const LTRTextDirectionIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_2)">
      <path d="M9.4954 0C8.51343 0 7.56853 0.389676 6.87374 1.08553C6.17896 1.78138 5.78988 2.72773 5.78988 3.7112C5.78988 4.69467 6.17896 5.64103 6.87374 6.33688C7.56853 7.03273 8.51343 7.42241 9.4954 7.42241V14.8448H11.3482V1.8556H14.1273V14.8448H15.9801V1.8556H17.8328V0H9.4954Z" fill="#647696" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20.5709 19.2797L19.0686 17.691L20.4138 16.415L24 20.2075L20.4138 24L19.0686 22.724L20.5709 21.1353H0V19.2797H20.5709Z" fill="#647696" />
    </g>
    <defs>
      <clipPath id="clip0_1_2">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const RegionIcon = () => {
  return (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 0C2.68447 0 0 2.68794 0 6C0 8.22241 0.749719 8.91691 4.72722 15.2945C5.31425 16.2357 6.68641 16.2346 7.27275 15.2945C11.2523 8.91357 12 8.22197 12 6C12 2.68447 9.31207 0 6 0ZM6 14.5C2.018 8.11519 1.5 7.71213 1.5 6C1.5 3.51472 3.51472 1.5 6 1.5C8.48528 1.5 10.5 3.51472 10.5 6C10.5 7.70478 10.0261 8.04454 6 14.5ZM3.5 6C3.5 4.61928 4.61928 3.5 6 3.5C7.38072 3.5 8.5 4.61928 8.5 6C8.5 7.38072 7.38072 8.5 6 8.5C4.61928 8.5 3.5 7.38072 3.5 6Z" fill="#647696" />
    </svg>
  )
}

export const CenterAlignmentIcon = () => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H16V2H0V0Z" fill="#647696" />
    <path d="M3 4H13V6H3V4Z" fill="#647696" />
    <path d="M16 8H0V10H16V8Z" fill="#647696" />
    <path d="M3 12H13V14H3V12Z" fill="#647696" />
  </svg>
)

export const JustifyAlignmentIcon = () => (
  <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0H16V2H0V0Z" fill="#647696" />
    <path d="M0 4H16V6H0V4Z" fill="#647696" />
    <path d="M16 8H0V10H16V8Z" fill="#647696" />
    <path d="M0 12H16V14H0V12Z" fill="#647696" />
  </svg>
)

// Table Icons
export const TableIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 10H0V12H7V10Z" fill="#647696" />
    <path d="M16 10H9V12H16V10Z" fill="#647696" />
    <path d="M7 14H0V16H7V14Z" fill="#647696" />
    <path d="M16 14H9V16H16V14Z" fill="#647696" />
    <path d="M0 0V8H16V0H0ZM7 6H2V2H7V6ZM14 6H9V2H14V6Z" fill="#647696" />
  </svg>
)

export const MergeCellsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" fill="#475161" d="M3.78182 2C2.79775 2 2 2.79775 2 3.78182V22.1091C2 23.0932 2.79775 23.8909 3.78182 23.8909H8.1092V28.2182C8.1092 29.2023 8.90695 30 9.89102 30H28.2182C29.2023 30 30 29.2023 30 28.2182V9.89091C30 8.90684 29.2023 8.10909 28.2182 8.10909H23.8908V3.78182C23.8908 2.79775 23.093 2 22.109 2H3.78182ZM9.63648 17.8017V22.3636H14.2181C14.6399 22.3636 14.9818 22.7055 14.9818 23.1273C14.9818 23.549 14.6399 23.8909 14.2181 23.8909H9.63648V28.2182C9.63648 28.3588 9.75044 28.4727 9.89102 28.4727H28.2182C28.3588 28.4727 28.4727 28.3588 28.4727 28.2182V9.89091C28.4727 9.75033 28.3588 9.63636 28.2182 9.63636H23.8908V14.1983C23.8908 14.62 23.5489 14.9619 23.1272 14.9619C22.7054 14.9619 22.3635 14.62 22.3635 14.1983V9.63636H17.7819C17.3601 9.63636 17.0182 9.29447 17.0182 8.87273C17.0182 8.45098 17.3601 8.10909 17.7819 8.10909H22.3635V3.78182C22.3635 3.64124 22.2496 3.52727 22.109 3.52727H3.78182C3.64124 3.52727 3.52727 3.64124 3.52727 3.78182V22.1091C3.52727 22.2497 3.64124 22.3636 3.78182 22.3636H8.1092V17.8017C8.1092 17.38 8.4511 17.0381 8.87284 17.0381C9.29458 17.0381 9.63648 17.38 9.63648 17.8017ZM22.1091 23.8908C23.0932 23.8908 23.8909 23.093 23.8909 22.109V18.0362C23.8909 17.6145 23.549 17.2726 23.1273 17.2726C22.7055 17.2726 22.3636 17.6145 22.3636 18.0362V22.109C22.3636 22.2495 22.2497 22.3635 22.1091 22.3635H18.0364C17.6146 22.3635 17.2728 22.7054 17.2728 23.1271C17.2728 23.5489 17.6146 23.8908 18.0364 23.8908H22.1091ZM9.89091 8.10923C8.90684 8.10923 8.10909 8.90698 8.10909 9.89105V13.9638C8.10909 14.3855 8.45098 14.7274 8.87273 14.7274C9.29447 14.7274 9.63636 14.3855 9.63636 13.9638V9.89105C9.63636 9.75047 9.75033 9.6365 9.89091 9.6365H13.9636C14.3854 9.6365 14.7272 9.29461 14.7272 8.87287C14.7272 8.45112 14.3854 8.10923 13.9636 8.10923H9.89091Z" />
  </svg>
)


export const UnMergeCellsIcon = () => (
  <svg width="19" height="19" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#475161" d="M20.9531 22.7221C21.9301 22.7221 22.7221 21.9302 22.7221 20.9532L22.7221 10.5921H28.0289C28.1685 10.5921 28.2816 10.7053 28.2816 10.8448V19.355C28.2816 19.7737 28.6211 20.1131 29.0398 20.1131C29.4585 20.1131 29.7979 19.7737 29.7979 19.355V10.8448C29.7979 9.86785 29.0059 9.07586 28.0289 9.07586H22.7221V3.76896C22.7221 2.79199 21.9301 2 20.9531 2H12.4242C12.0055 2 11.6661 2.33942 11.6661 2.75813C11.6661 3.17683 12.0055 3.51625 12.4242 3.51625L20.9531 3.51625C21.0927 3.51625 21.2058 3.6294 21.2058 3.76896L21.2058 20.9532C21.2058 21.0928 21.0927 21.2059 20.9531 21.2059L3.76896 21.2059C3.62939 21.2059 3.51625 21.0928 3.51625 20.9532L3.51625 12.443C3.51625 12.0243 3.17682 11.6849 2.75812 11.6849C2.33942 11.6849 2 12.0243 2 12.443V20.9532C2 21.9302 2.79199 22.7221 3.76896 22.7221H8.06499V28.029C8.06499 29.006 8.85698 29.798 9.83395 29.798H18.8649C19.2836 29.798 19.6231 29.4586 19.6231 29.0399C19.6231 28.6212 19.2836 28.2818 18.8649 28.2818H9.83395C9.69438 28.2818 9.58124 28.1686 9.58124 28.029V22.7221L20.9531 22.7221Z M3.76896 2.00012C2.79199 2.00012 2 2.79212 2 3.76909V6.59942C2 7.01812 2.33943 7.35755 2.75813 7.35755C3.17683 7.35755 3.51625 7.01812 3.51625 6.59942L3.51625 4.57691L7.46967 8.53033C7.76256 8.82322 8.23744 8.82322 8.53033 8.53033C8.82322 8.23744 8.82322 7.76256 8.53033 7.46967L4.57704 3.51638L6.59928 3.51638C7.01798 3.51638 7.3574 3.17695 7.3574 2.75825C7.3574 2.33955 7.01798 2.00012 6.59928 2.00012L3.76896 2.00012Z M28.231 30C29.208 30 30 29.208 30 28.231V25.4007C30 24.982 29.6606 24.6426 29.2419 24.6426C28.8232 24.6426 28.4838 24.982 28.4838 25.4007V27.4231L24.5303 23.4697C24.2374 23.1768 23.7626 23.1768 23.4697 23.4697C23.1768 23.7626 23.1768 24.2374 23.4697 24.5303L27.4231 28.4837H25.4007C24.982 28.4837 24.6426 28.8232 24.6426 29.2419C24.6426 29.6606 24.982 30 25.4007 30H28.231Z" />
  </svg>
)


export const TableCreateIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8009 -3.05176e-05C13.2151 -3.05176e-05 13.5509 0.335756 13.5509 0.749969V2.46163H15.2616C15.6758 2.46163 16.0116 2.79742 16.0116 3.21163C16.0116 3.62584 15.6758 3.96163 15.2616 3.96163H13.5509V5.67297C13.5509 6.08719 13.2151 6.42297 12.8009 6.42297C12.3867 6.42297 12.0509 6.08719 12.0509 5.67297V3.96163H10.3406C9.92634 3.96163 9.59055 3.62584 9.59055 3.21163C9.59055 2.79742 9.92634 2.46163 10.3406 2.46163H12.0509V0.749969C12.0509 0.335756 12.3867 -3.05176e-05 12.8009 -3.05176e-05ZM6.8614 2.25783H2V7.11923H6.8614V2.25783ZM2 0.25783H0V2.25783V7.11923V7.15003V9.11923V9.15003V14.0114V16.0114H2H6.8614H6.8922H8.8614H8.8922H13.7536H15.7536V14.0114V9.15003V7.15003H13.7536H8.8922H8.8614V7.11923V2.25783V0.25783H6.8614H2ZM6.8614 9.15003H2V14.0114H6.8614V9.15003ZM8.8922 9.15003H13.7536V14.0114H8.8922V9.15003Z"
      fill="#647696"
    />
  </svg>
)

export const TableDeleteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2H2V7H3.51176C3.36255 7.65766 3.36255 8.34234 3.51176 9H2V14H7V12.4096C7.6604 12.5437 8.34509 12.5286 9 12.3642V14H14V9H12.2879C12.4372 8.34234 12.4372 7.65766 12.2879 7H14V2H9V3.63585C8.34509 3.47141 7.6604 3.45626 7 3.59039V2ZM9 16H7H2H0V14V9V7V2V0H2H7H9H14H16V2V7V9V14V16H14H9ZM5.60089 5.70277C5.89378 5.40987 6.36866 5.40987 6.66155 5.70277L7.89899 6.9402L9.13585 5.70334C9.42874 5.41045 9.90361 5.41045 10.1965 5.70334C10.4894 5.99623 10.4894 6.47111 10.1965 6.764L8.95965 8.00086L10.1971 9.2383C10.49 9.53119 10.49 10.0061 10.1971 10.299C9.90419 10.5919 9.42932 10.5919 9.13642 10.299L7.89899 9.06152L6.66241 10.2981C6.36952 10.591 5.89465 10.591 5.60175 10.2981C5.30886 10.0052 5.30886 9.53033 5.60175 9.23744L6.83833 8.00086L5.60089 6.76343C5.308 6.47053 5.308 5.99566 5.60089 5.70277Z"
      fill="#647696"
    />
  </svg>
)

export const TableAddRowBeforeIcon = React.forwardRef<SVGSVGElement>((props, ref) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2H7V7H2V2ZM9 9H8.5V15H15V9H14H9ZM8.5 16H7.5H1H0V15V9V8V7V2V0H2H7H9H14H16V2V7V8V9V15V16H15H8.5ZM14 7V2H9V7H14ZM2 9H1V15H7.5V9H7H2Z"
      fill="#647696"
    />
  </svg>
))

export const TableAddRowAfterIcon = React.forwardRef<SVGSVGElement>((props, ref) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 1H1V7H2H7H7.5V1ZM7.5 0H1H0V1V7V8V9V14V16H2H7H9H14H16V14V9V8V7V1V0H15H8.5H7.5ZM15 7V1H8.5V7H9H14H15ZM14 9H9V14H14V9ZM2 14V9H7V14H2Z"
      fill="#647696"
    />
  </svg>
))

export const TableDeleteRowIcon = React.forwardRef<SVGSVGElement>((props, ref) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.5 4H0V2H0.5H1V4H0.5ZM0 1V0.5V0H0.5H0.944445H1V1H0.944445H0.5H0ZM3 0H1.88889V0.5V1H3V0ZM0 8.5V9V14V16H2H7H9H14H16V14V9V8.5V8V7V5H15.5H15V7H14H9H7H2H1V5H0.5H0V7V8V8.5ZM7 9H6.61111H4.72222H3.77778H2V14H7V9ZM9 14H14V9H12.2222H11.2778H9.38889H9V14ZM14.1111 1H13V0H14.1111V0.5V1ZM16 1V0.5V0H15.5H15.0556H15V1L15.0556 1L15.5 1L16 1ZM16 2H15.5H15V4H15.5H16V2ZM10.2823 1.18708C10.5752 1.47997 10.5752 1.95484 10.2823 2.24774L9.04485 3.48517L10.2817 4.72203C10.5746 5.01492 10.5746 5.48979 10.2817 5.78269C9.98882 6.07558 9.51394 6.07558 9.22105 5.78269L7.98419 4.54583L6.74675 5.78327C6.45386 6.07616 5.97898 6.07616 5.68609 5.78327C5.3932 5.49038 5.3932 5.0155 5.68609 4.72261L6.92353 3.48517L5.68695 2.24859C5.39406 1.9557 5.39406 1.48082 5.68695 1.18793C5.97985 0.895038 6.45472 0.895038 6.74762 1.18793L7.98419 2.42451L9.22162 1.18708C9.51452 0.894184 9.98939 0.894184 10.2823 1.18708Z"
      fill="#647696"
    />
  </svg>
))

export const TableAddColumnAboveIcon = React.forwardRef<SVGSVGElement>((props, ref) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 14L2 9L7 9L7 14L2 14ZM9 7L9 7.5L15 7.5L15 1L9 1L9 2L9 7ZM16 7.5L16 8.5L16 15L16 16L15 16L9 16L8 16L7 16L2 16L0 16L2.38498e-08 14L8.34742e-08 9L1.07324e-07 7L1.66948e-07 2L1.90798e-07 0L2 2.38498e-08L7 8.34742e-08L8 9.5399e-08L9 1.07324e-07L15 1.78873e-07L16 1.90798e-07L16 1L16 7.5ZM7 2L2 2L2 7L7 7L7 2ZM9 14L9 15L15 15L15 8.5L9 8.5L9 9L9 14Z"
      fill="#647696"
    />
  </svg>
))

export const TableAddColumnBelowIcon = React.forwardRef<SVGSVGElement>((props, ref) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 8.5L1 15L7 15L7 14L7 9L7 8.5L1 8.5ZM8.94366e-08 8.5L1.19249e-08 15L0 16L1 16L7 16L8 16L9 16L14 16L16 16L16 14L16 9L16 7L16 2L16 1.90798e-07L14 1.66948e-07L9 1.07324e-07L8 9.5399e-08L7 8.34742e-08L1 1.19249e-08L1.90798e-07 0L1.78873e-07 1L1.01361e-07 7.5L8.94366e-08 8.5ZM7 1L1 1L1 7.5L7 7.5L7 7L7 2L7 1ZM9 2L9 7L14 7L14 2L9 2ZM14 14L9 14L9 9L14 9L14 14Z"
      fill="#647696"
    />
  </svg>
))

export const TableDeleteColumnIcon = React.forwardRef<SVGSVGElement>((props, ref) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 15.5L4 16L2 16L2 15.5L2 15L4 15L4 15.5ZM1 16L0.5 16L0 16L5.96244e-09 15.5L1.12624e-08 15.0556L1.19249e-08 15L1 15L1 15.0556L1 15.5L1 16ZM3.57746e-08 13L2.25248e-08 14.1111L0.5 14.1111L1 14.1111L1 13L3.57746e-08 13ZM8.5 16L9 16L14 16L16 16L16 14L16 9L16 7L16 2L16 1.90798e-07L14 1.66948e-07L9 1.07324e-07L8.5 1.01361e-07L8 9.5399e-08L7 8.34742e-08L5 5.96244e-08L5 0.5L5 1L7 1L7 2L7 7L7 9L7 14L7 15L5 15L5 15.5L5 16L7 16L8 16L8.5 16ZM9 9L9 9.38889L9 11.2778L9 12.2222L9 14L14 14L14 9L9 9ZM14 7L14 2L9 2L9 3.77778L9 4.72222L9 6.61111L9 7L14 7ZM1 1.88889L1 3L1.55023e-07 3L1.68273e-07 1.88889L0.5 1.88889L1 1.88889ZM1 1.19249e-08L0.5 5.96244e-09L1.90798e-07 0L1.84836e-07 0.5L1.79536e-07 0.944445L1.78873e-07 1L1 1L1 0.944445L1 0.5L1 1.19249e-08ZM2 2.38498e-08L2 0.5L2 1L4 1L4 0.5L4 4.76995e-08L2 2.38498e-08ZM1.18708 5.71772C1.47997 5.42482 1.95484 5.42482 2.24774 5.71772L3.48517 6.95515L4.72203 5.71829C5.01492 5.4254 5.48979 5.4254 5.78269 5.71829C6.07558 6.01118 6.07558 6.48606 5.78269 6.77895L4.54583 8.01581L5.78327 9.25325C6.07616 9.54614 6.07616 10.021 5.78327 10.3139C5.49038 10.6068 5.0155 10.6068 4.72261 10.3139L3.48517 9.07647L2.24859 10.313C1.9557 10.6059 1.48082 10.6059 1.18793 10.313C0.895038 10.0202 0.895039 9.54528 1.18793 9.25238L2.42451 8.01581L1.18708 6.77838C0.894184 6.48548 0.894184 6.01061 1.18708 5.71772Z"
      fill="#647696"
    />
  </svg>
))

export const SeeMoreIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 2C4 3.10457 3.10457 4 2 4C0.89543 4 0 3.10457 0 2C0 0.895431 0.89543 0 2 0C3.10457 0 4 0.895431 4 2Z"
      fill="#647696"
    />
    <path
      d="M10 2C10 3.10457 9.10457 4 8 4C6.89543 4 6 3.10457 6 2C6 0.895431 6.89543 0 8 0C9.10457 0 10 0.895431 10 2Z"
      fill="#647696"
    />
    <path
      d="M14 4C15.1046 4 16 3.10457 16 2C16 0.895431 15.1046 0 14 0C12.8954 0 12 0.895431 12 2C12 3.10457 12.8954 4 14 4Z"
      fill="#647696"
    />
  </svg>
)

export const InlineCodeIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M5.91893 16V14.2558C4.4392 14.2558 4.08658 13.6513 4.08658 12.3416V10.2763C4.08658 9.29397 3.69618 8.4628 1.99606 8.12278V7.8835C3.69618 7.54348 4.08658 6.70601 4.08658 5.72372V3.65839C4.08658 2.35497 4.4392 1.75048 5.91893 1.75048V-7.62939e-06C3.40024 -7.62939e-06 1.9205 0.635962 1.9205 3.47579V5.08146C1.9205 6.40377 1.42936 6.94529 0 6.94529V9.06099C1.42936 9.06099 1.9205 9.60251 1.9205 10.9248V12.5242C1.9205 15.364 3.40024 16 5.91893 16Z"
        fill="#647696"
      />
      <path
        d="M10.0811 -5.17449e-07L10.0811 1.74419C11.5608 1.74419 11.9134 2.34868 11.9134 3.6584L11.9134 5.72373C11.9134 6.70602 12.3038 7.53719 14.0039 7.87721L14.0039 8.11649C12.3038 8.45651 11.9134 9.29398 11.9134 10.2763L11.9134 12.3416C11.9134 13.645 11.5608 14.2495 10.0811 14.2495L10.0811 16C12.5998 16 14.0795 15.364 14.0795 12.5242L14.0795 10.9185C14.0795 9.59622 14.5706 9.0547 16 9.0547L16 6.939C14.5706 6.939 14.0795 6.39748 14.0795 5.07517L14.0795 3.4758C14.0795 0.635971 12.5998 -2.97258e-07 10.0811 -5.17449e-07Z"
        fill="#647696"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
export const EmojiIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.25 8C14.25 11.4518 11.4518 14.25 8 14.25C4.54822 14.25 1.75 11.4518 1.75 8C1.75 4.54822 4.54822 1.75 8 1.75C11.4518 1.75 14.25 4.54822 14.25 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.65064 9.50086L5.65044 9.50064C5.37511 9.19207 4.9018 9.16458 4.59258 9.43944C4.28299 9.71463 4.25511 10.1887 4.5303 10.4983L5.09085 10C4.5303 10.4983 4.53045 10.4984 4.53061 10.4986L4.53096 10.499L4.53175 10.4999L4.53369 10.5021L4.53903 10.508L4.55545 10.5259C4.56892 10.5404 4.58743 10.5601 4.61075 10.5842C4.65734 10.6323 4.72341 10.6983 4.80706 10.7762C4.97363 10.9313 5.21385 11.1372 5.51243 11.3439C6.09589 11.7478 6.97407 12.2045 7.99995 12.2045C9.02582 12.2045 9.90401 11.7478 10.4875 11.3439C10.786 11.1372 11.0263 10.9313 11.1928 10.7762C11.2765 10.6983 11.3426 10.6323 11.3891 10.5842C11.4125 10.5601 11.431 10.5404 11.4444 10.5259L11.4609 10.508L11.4662 10.5021L11.4681 10.4999L11.4689 10.499L11.4693 10.4986C11.4694 10.4985 11.4696 10.4983 10.9334 10.0216L11.4696 10.4983C11.7448 10.1887 11.7169 9.71463 11.4073 9.43944C11.098 9.16454 10.6247 9.19208 10.3493 9.50075L10.349 9.50111L10.3488 9.5014L10.3438 9.50678C10.3375 9.51354 10.3267 9.5251 10.3115 9.54079C10.2811 9.57222 10.2335 9.61987 10.1707 9.67835C10.0443 9.796 9.86032 9.9537 9.63364 10.1106C9.16659 10.434 8.59024 10.7045 7.99995 10.7045C7.40966 10.7045 6.8333 10.434 6.36625 10.1106C6.13957 9.9537 5.95555 9.796 5.82919 9.67835C5.76638 9.61987 5.71881 9.57222 5.68838 9.54079C5.67319 9.5251 5.66235 9.51354 5.65609 9.50678L5.65112 9.5014L5.65086 9.50111L5.65064 9.50086ZM5.65112 9.5014L5.65141 9.50173L5.09085 10C5.65141 9.50173 5.65127 9.50156 5.65112 9.5014ZM7 6C7 5.4 6.6 5 6 5C5.4 5 5 5.4 5 6C5 6.6 5.4 7 6 7C6.6 7 7 6.6 7 6ZM10 5C10.6 5 11 5.4 11 6C11 6.6 10.6 7 10 7C9.4 7 9 6.6 9 6C9 5.4 9.4 5 10 5Z"
      fill="#647696"
    />
  </svg>
)

export const NewFolderIcon = () => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="AddFolder Icon--default"
    name="AddCircle">
    <rect
      x="0.5"
      y="23.5"
      width="23"
      height="23"
      rx="11.5"
      transform="rotate(-90 .5 23.5)"
      fill="#fff"
      stroke="#6C5CE7"></rect>
    <path d="M12.4 8h-.8v3.6H8v.8h3.6V16h.8v-3.6H16v-.8h-3.6V8z" fill="#6C5CE7"></path>
  </svg>
)

export const NewFolderIconLarge = () => (
  <svg
    width="60"
    height="60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="Icon--default"
    name="AddCircleLarge">
    <rect
      x="1"
      y="59"
      width="58"
      height="58"
      rx="29"
      transform="rotate(-90 1 59)"
      fill="#fff"
      stroke="#6C5CE7"
      strokeWidth="2"></rect>
    <path d="M31 20h-2v9h-9v2h9v9h2v-9h9v-2h-9v-9z" fill="#6C5CE7"></path>
  </svg>
)

export const TagCancelIcon = () => {
  return (
    <svg className="Icon--default" name="CancelSec" height="11" width="11" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1l6 6M1 7l6-6" stroke="#A9B6CB" strokeWidth="1.5" strokeLinecap="round"></path>
    </svg>
  )
}

export const InfoIcon = () => {
  return (
    <svg className="Icon--default" name="Help" height="12" width="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.344 10.719a.656.656 0 1 1 1.312 0 .656.656 0 0 1-1.312 0zM6.028 4.729c.228-.458.632-.823 1.19-.823.309 0 .61.105.821.27.205.159.305.353.305.564 0 .363-.06.51-.139.62-.107.15-.303.312-.75.61-.524.349-.84.738-1.004 1.176-.15.4-.15.79-.149 1.066v.03a.625.625 0 1 0 1.25 0c0-.307.006-.487.07-.657.054-.146.176-.341.527-.575.428-.286.815-.562 1.073-.923.285-.399.372-.835.372-1.347 0-.665-.336-1.2-.787-1.55a2.613 2.613 0 0 0-1.588-.534c-1.197 0-1.955.803-2.31 1.515a.625.625 0 0 0 1.12.558z" fill="#647696"></path><path fillRule="evenodd" clipRule="evenodd" d="M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14zm0-1.25a5.75 5.75 0 1 0 0-11.5 5.75 5.75 0 0 0 0 11.5z" fill="#647696"></path></svg>
  )
}

export const AssetIcon = () => {
  return (
    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M1 0C0.447715 0 0 0.447715 0 1V13C0 13.5523 0.447715 14 1 14H2V12V3V2H3H7H9.41421C9.50665 2 9.59776 2.0128 9.68519 2.03741L8.12132 0.292893C7.93378 0.105357 7.67943 0 7.41421 0H1Z" fill="#647696" />
      <path fillRule="evenodd" clipRule="evenodd" d="M3 3.92857C3 3.41574 3.41574 3 3.92857 3H9.88463C10.1309 3 10.3671 3.09783 10.5412 3.27197L13.8709 6.98626C14.045 7.1604 14.1429 7.39658 14.1429 7.64286V15.0714C14.1429 15.5843 13.7271 16 13.2143 16H3.92857C3.41574 16 3 15.5843 3 15.0714V3.92857ZM4.85714 4.85714V14.1429H12.2857V8.02748L9.5 4.85714H4.85714Z" fill="#647696" />
    </svg>
  )
}
